import { lockboxesApi } from ".";

export const loadLockboxOptions = async (
  search: string,
  _: unknown,
  { page, propertyId }: { page: number; propertyId: number }
) => {
  const data = await lockboxesApi.getLockboxes({
    property_id: propertyId,
    available: true,
    search: search || undefined,
    page
  });

  return {
    options: data.items.map((lb) => ({
      value: lb.id,
      label: lb.name
    })),
    hasMore: data.has_more,
    additional: { page: page + 1, propertyId }
  };
};
